/**
 * Defines the theming colors.
 */

const clay = 'hsl(215, 17%, 26%)';

export const palette = {
  clay,
};
